export default function isIPad() {
  return navigator.userAgent.match(/iPad/i) != null;
}



// WEBPACK FOOTER //
// ./scripts/util/isIPad.js